<!-- 总代理商首页 -->
<template>
  <div class="container">
    <div class="header">
      <p class="title">客户统计</p>
      <div class="h_body">
        <div class="h_item">
          <div class="h_l">
            <p>注册用户</p>
            <p>{{ userData.user_count }}</p>
          </div>
          <div class="h_r">
            <img src="../../../assets/注册用户.png" alt="">
          </div>
        </div>
        <div class="h_item">
          <div class="h_l">
            <p>未分配</p>
            <p>{{ userData.on_allocation_user }}</p>
          </div>
          <div class="h_r">
            <img src="../../../assets/未分配.png" alt="">
          </div>
        </div>
        <div class="h_item">
          <div class="h_l">
            <p>已分配</p>
            <p>{{ userData.allocation_user }}</p>
          </div>
          <div class="h_r">
            <img src="../../../assets/已分配.png" alt="">
          </div>
        </div>
        <div class="h_item">
          <div class="h_l">
            <p>未成交</p>
            <p>{{ userData.no_prive_user }}</p>
          </div>
          <div class="h_r">
            <img src="../../../assets/未成交.png" alt="">
          </div>
        </div>
        <div class="h_item">
          <div class="h_l">
            <p>已成交</p>
            <p>{{ userData.prive_user }}</p>
          </div>
          <div class="h_r">
            <img src="../../../assets/已成交.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="b_l">
        <p class="title">全国用户统计</p>
        <div class="b_l_b">
          <div id="user_country" style="width: 54rem;height: 41.8rem"></div>
          <div class="b_l_table">
            <div class="table_h">全国用户数据统计（个数）</div>
            <template v-if="tableData.length">
              <div class="table_cell" v-for="(item, index) in tableData" :key="index">
                <div class="cell_l" v-if="index == 0">
                  <img src="../../../assets/第一.png" alt="">
                  <p>TOP1</p>
                </div>
                <div class="cell_l" v-else-if="index == 1">
                  <img src="../../../assets/第二.png" alt="">
                  <p>TOP2</p>
                </div>
                <div class="cell_l" v-else>
                  <img src="../../../assets/第三.png" alt="">
                  <p>TOP3</p>
                </div>
                <div class="cell_c">{{ item.name }}</div>
                <div class="cell_r">{{ item.value }}</div>
              </div>
            </template>
            <div v-else class="table_cell cell_c font">暂无数据</div>
          </div>
        </div>
      </div>
      <div class="b_c">
        <p class="title">金额统计</p>
        <div class="b_c_b">
          <div id="money" style="width: 100%; height: 45rem"></div>
          <div class="legend">
            <div class="m_item">
              <p class="square1"></p>
              <p>等待审核金额数</p>
              <p>{{ moneyData.if_status_one }}</p>
            </div>
            <div class="m_item">
              <p class="square2"></p>
              <p>审核通过金额数</p>
              <p>{{ moneyData.if_status_two }}</p>
            </div>
            <div class="m_item">
              <p class="square3"></p>
              <p>驳回金额数</p>
              <p>{{ moneyData.if_status_therr }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="b_r">
        <p class="title">代理商信息</p>
        <div class="b_r_b">
          <div id="agent" style="width: 100%; height: 45rem"></div>
          <div class="legend">
            <div class="m_item">
              <p class="square1"></p>
              <p>代理商数量</p>
              <p>{{ agentData.agent_user }}</p>
            </div>
            <div class="m_item">
              <p class="square2"></p>
              <p>上传预付费条数</p>
              <p>{{ agentData.agent_money }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
let ming = require("echarts/lib/echarts");
// 引入地图
require("echarts/map/js/china.js");
// 引入饼状图组件
require("echarts/lib/chart/pie");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      userData: [], //客户统计统计
      tableData: [], //前三条省份用户数据
      provinceData: [],  //echarts全国省份数据
      agentData: [], //代理商数据统计
      moneyData: [],  //金额统计数据
      tooken: "",
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
      var userAgent = navigator.userAgent;
      var isLessIE11 =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
      if (isLessIE11) {
        this.$message.error(
          "当前浏览器版本过低可能导致后台与浏览器不兼容，升级浏览器即可"
        );
      }
    }
    this.provinceD();
    this.userD();
    this.agentD();
    this.moneyD();
  },

  methods: {
    // 客户统计
    userD() {
      this.axios
        .post(
          "/api/index/userneed",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          if (res.data.code == 1) {
            this.userData = res.data.data;
          }
        })
        .catch(function (err) { });
    },
    // 省份用户数据
    provinceD() {
      this.axios
        .post(
          "/api/Index/getProvinces",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          if (res.data.code == 1) {
            let data = [];  //value值不为0的数据
            let arr = [];  //全国数据
            data = res.data.data.filter(item => {
              return item.value > 0
            })
            let arrs = data.slice(0, 3);  //前三条数据
            let compare = function (a, b) {  //排序函数
              var val1 = a.value;
              var val2 = b.value;
              if (val1 < val2) {
                return 1;
              } else if (val1 > val2) {
                return -1;
              } else {
                return 0;
              }
            }
            this.tableData = arrs.sort(compare);
            res.data.data.forEach((item, index) => {
              arr[index] = {
                name: item.name,
                num: item.value,
                value: index + 1,
                selected: false,
              };
            });
            this.provinceData = arr;
            this.getUserCountry();
          }
        })
        .catch(function (err) { });
    },
    // 绘制地图
    getUserCountry() {
      var myChart = echarts.init(document.getElementById("user_country"));
      var data = this.provinceData;
      var yData = [];
      window.addEventListener("resize", function (event) {
        myChart.resize();
      });

      data.sort(function (o1, o2) {
        if (isNaN(o1.num) || o1.num == null) return -1;
        if (isNaN(o2.num) || o2.num == null) return 1;
        return o1.num - o2.num;
      });
      for (var i = 0; i < data.length; i++) {
        yData.push(data[i].name);
      }

      var option = {
        tooltip: {
          show: true,
          formatter: function (params) {
            return params.name + "：" + params.data["num"] + "位";
          },
        },
        series: [
          {
            name: "mapSer",
            type: "map",
            mapType: "china",
            selectedMode: "single",
            itemStyle: {
              normal: {
                label: { show: true },
                borderWidth: 0.5, //省份的边框宽度
                borderColor: "#999999", //省份的边框颜色
                color: "#ece2df", //地图背景颜色
                areaStyle: { color: "#f60" }, //设置地图颜色
              },
              emphasis: { label: { show: true } },
            },
            top: "30",
            data: data,
          },
        ],
        dataRange: {
          x: "-700 px", //图例横轴位置
          y: "-700 px", //图例纵轴位置
          splitList: [
            { start: 1, end: 1, label: "北京", color: "#6B8DC1" },
            { start: 2, end: 2, label: "天津", color: "#6B8DC1" },
            { start: 3, end: 3, label: "河北", color: "#6B8DC1" },
            { start: 4, end: 4, label: "山西", color: "#6B8DC1" },
            { start: 5, end: 5, label: "内蒙古", color: "#6B8DC1" },
            { start: 6, end: 6, label: "辽宁", color: "#6B8DC1" },
            { start: 7, end: 7, label: "吉林", color: "#6B8DC1" },
            { start: 8, end: 8, label: "黑龙江", color: "#6B8DC1" },
            { start: 9, end: 9, label: "上海", color: "#6B8DC1" },
            { start: 10, end: 10, label: "江苏", color: "#6B8DC1" },
            { start: 11, end: 11, label: "浙江", color: "#6B8DC1" },
            { start: 12, end: 12, label: "安徽", color: "#6B8DC1" },
            { start: 13, end: 13, label: "福建", color: "#6B8DC1" },
            { start: 14, end: 14, label: "江西", color: "#6B8DC1" },
            { start: 15, end: 15, label: "山东", color: "#6B8DC1" },
            { start: 16, end: 16, label: "河南", color: "#6B8DC1" },
            { start: 17, end: 17, label: "湖北", color: "#6B8DC1" },
            { start: 18, end: 18, label: "湖南", color: "#6B8DC1" },
            { start: 19, end: 19, label: "广东", color: "#6B8DC1" },
            { start: 20, end: 20, label: "广西", color: "#6B8DC1" },
            { start: 21, end: 21, label: "海南", color: "#6B8DC1" },
            { start: 22, end: 22, label: "重庆", color: "#6B8DC1" },
            { start: 23, end: 23, label: "四川", color: "#6B8DC1" },
            { start: 24, end: 24, label: "贵州", color: "#6B8DC1" },
            { start: 25, end: 25, label: "云南", color: "#6B8DC1" },
            { start: 26, end: 26, label: "西藏", color: "#6B8DC1" },
            { start: 27, end: 27, label: "陕西", color: "#6B8DC1" },
            { start: 28, end: 28, label: "甘肃", color: "#6B8DC1" },
            { start: 29, end: 29, label: "青海", color: "#6B8DC1" },
            { start: 30, end: 30, label: "宁夏", color: "#6B8DC1" },
            { start: 31, end: 31, label: "新疆", color: "#6B8DC1" },
            { start: 32, end: 32, label: "台湾", color: "#6B8DC1" },
            { start: 33, end: 33, label: "香港", color: "#6B8DC1" },
            { start: 34, end: 34, label: "澳门", color: "#6B8DC1" },
          ],
        },
      };
      myChart.setOption(option);
    },
    //  金额统计
    moneyD() {
      this.axios
        .post(
          "/api/index/totalMoney",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }

          this.moneyData = res.data.data;
          var myChart = echarts.init(document.getElementById("money"));
          window.addEventListener("resize", function (event) {
            myChart.resize();
          });

          var color = ["#49B372", "#BBF4D2", "#839BFB"];
          // 绘制图表
          myChart.setOption({
            color: color,
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b}: {c} ({d}%)",
            },
            series: [
              {
                name: "金额",
                type: "pie",
                radius: ["40%", "80%"],
                center: ["50%", "50%"],
                data: [
                  { value: this.moneyData.if_status_one, name: "等待审核金额数" },
                  { value: this.moneyData.if_status_two, name: "审核通过金额数" },
                  { value: this.moneyData.if_status_therr, name: "驳回金额数" },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          });
        })
        .catch(function (err) { });
    },
    //代理商信息
    agentD() {
      this.axios
        .post(
          "/api/index/agentNumber",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.agentData = res.data.data;
          let myChart = this.$echarts.init(document.getElementById("agent"));
          window.addEventListener("resize", function (event) {
            myChart.resize();
          });
          var color = ["#BBF4D2", "#49B372"];
          myChart.setOption({
            color: color,
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                name: "代理商",
                type: "pie",
                radius: ["40%", "80%"],
                center: ["50%", "50%"],
                data: [
                  { value: this.agentData.agent_user, name: "代理商数量" },
                  { value: this.agentData.agent_money, name: "上传预付费条数" },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          });
        })
        .catch(function (err) { });
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 2.4rem;
  font-weight: 500;
  color: #333333;
  line-height: 3.3rem;
  margin-bottom: 1.5rem;
}

.h_body {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.h_item {
  width: 31.6rem;
  display: flex;
  justify-content: space-between;
  padding: 3rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
  border-radius: .8rem;
  border: 1px solid #F6F6F6;
}

.h_l p:first-child {
  font-size: 2.1rem;
  font-weight: 400;
  color: #666666;
  line-height: 2.9rem;
  margin-bottom: 2rem;
}

.h_l p:last-child {
  font-size: 4.8rem;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #333333;
  line-height: 5.6rem;
}

.h_r img {
  width: 6rem;
  height: 6rem;
}

.body {
  display: flex;
  justify-content: space-between;
}

.b_l,
.b_c,
.b_r {
  width: 54rem;
}

.b_l_b,
.b_c_b,
.b_r_b {
  padding-bottom: 4rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
  border-radius: .8rem;
}

.b_c_b {
  padding: 4rem 0 4.5rem;
}

.b_r_b {
  padding: 4rem 0 9.3rem;
}

.b_l_table {
  padding: 0 3rem;
}

.table_h {
  text-align: center;
  background: #F6FFFA;
  border-radius: 2.5rem;
  padding: 1rem 0;
  font-size: 2.1rem;
  font-weight: 500;
  color: #49B372;
  line-height: 2.9rem;
}

.table_cell {
  display: flex;
  justify-content: space-between;
  padding: 1.9rem 3rem;
  border-bottom: 1px solid #E6E6E6;
}

.font {
  justify-content: center;
}

.cell_l {
  display: flex;
}

.cell_l img {
  width: 3rem;
  height: 2rem;
  margin-right: 1rem;
}

.cell_l p,
.cell_c {
  font-size: 1.6rem;
  font-weight: 400;
  color: #333333;
  line-height: 2.2rem;
}

.cell_r {
  font-size: 2.1rem;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #333333;
  line-height: 2.5rem;
}

.legend {
  margin-top: 2rem;
  padding-left: 18rem;
}

.m_item {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.square1,
.square2,
.square3 {
  width: 1rem;
  height: 1rem;
  background: #49B372;
  border-radius: .2rem;
  margin-right: 1rem;
}

.square2 {
  background: #BBF4D2;
}

.square3 {
  background: #839BFB;
}

.m_item p:nth-child(2) {
  font-size: 1.4rem;
  font-weight: 400;
  color: #999999;
  line-height: 2rem;
  margin-right: 2rem;
}

.m_item p:last-child {
  font-size: 2.4rem;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #333333;
  line-height: 2.8rem;
}</style>
